import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantAssociation from './tenant-association';
import TenantAssociationDetail from './tenant-association-detail';
import TenantAssociationUpdate from './tenant-association-update';
import TenantAssociationDeleteDialog from './tenant-association-delete-dialog';

const TenantAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantAssociation />} />
    <Route path="new" element={<TenantAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<TenantAssociationDetail />} />
      <Route path="edit" element={<TenantAssociationUpdate />} />
      <Route path="delete" element={<TenantAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantAssociationRoutes;
